import type { Action } from '../typings/reducers';

type Payment = Record<string, unknown>;
type PaymentsState = { all: Payment[] } & Record<string, unknown>;

export default function (
  state: PaymentsState = { all: [], gateways: [] },
  action: Action
): PaymentsState {
  switch (action.type) {
    case 'SET_ALL_PAYMENTS':
      return { ...state, all: action.payload };
    case 'SET_PAYMENT_GATEWAY':
      return { ...state, [action.payload.type]: action.payload.data };
    default:
      return state;
  }
}
